exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-enter-active, .list-leave-active {\n  transition: all 1s;\n}\n.list-enter, .list-leave-to {\n  opacity: 0;\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n}", ""]);

// exports
